module.exports = __webpack_public_path__ + "static/img/g_5.c8e1ebf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/aboutcifi/g_5.jpg
// module id = 03Yv
// module chunks = 202